import { useState } from 'react'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * 📋 Chép nhanh mã đơn cạnh mã (bản cũ `CopyRef`, `Az.tsx:1007`) — mờ đi, rê vào mới đậm; bấm xong đổi ✅.
 * Dùng chung cho Đơn hàng (`/az/sales`) và Danh sách vận hành (`/az/ops`) — bản cũ cũng một component cho cả hai.
 * ⚠ Nhãn thuộc nhóm chuỗi `sales` — cả hai màn đều nạp nhóm đó.
 */
export const CopyRef = ({ text, className = '' }: { text: string; className?: string }): JSX.Element | null => {
  const { t } = useTranslation()
  const [done, setDone] = useState(false)
  if (text === '') return null
  return (
    <button type="button" title={done ? t('sales.table.copiedTitle') : t('sales.table.copyRefTitle', { ref: text })}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              void navigator.clipboard?.writeText(text)
              setDone(true)
              setTimeout(() => { setDone(false) }, 1200)
            }}
            className={`shrink-0 align-middle leading-none text-[10px] opacity-40 hover:opacity-100 transition ${done ? '!opacity-100' : ''} ${className}`}>
      {done ? '✅' : '📋'}
    </button>
  )
}
